<template lang="pug">
  v-hover(v-slot:default="{ hover }" :value="hover")
    tr(
      v-if="!showDelete || hideHover",
      :class="{ 'error-light-bg': removed && !hideHover }"
    )
      td(
        v-for="header in headers",
        :class="{ 'align-right': header.value === '' }",
      )
        //- action row
        div(v-if="header.value === ''")
          v-icon(
            small,
            v-show="hover && (isSuperadmin || item.creator_id === authUser.id)",
            :color="removed ? 'success' : 'error'",
            @click="showDelete = true",
          ) fas {{ removed ? 'fa-check' : 'fa-trash' }}

        //- date column
        div(v-else-if="header.type === 'date'")
          ColumnDate(
            :value="item[header.value]",
            :format="header.format",
          )

        div(v-else-if="header.type === 'button'")
          v-btn(
            outlined, small,
            color="primary",
            @click="$emit('selected')",
          ) {{ item[header.value] }}

        div(v-else-if="header.type === 'checkbox'")
          v-checkbox.ma-0.pa-0(
            hide-details,
            :disabled="isLoading",
            :ripple="false",
            :input-value="!item[header.value]",
            @click="$emit('toggle', { id: item.id, value: item[header.value] })",
          )

        //- thumbnail image
        div.d-flex(v-else-if="header.isImg")
          img.table_thumbnail(
            :src="propOrEmpty(header.display, item)",
          )

        //- router link
        router-link(
          v-else-if="header.isLink",
          :to="{ name: header.linkName , params: { id: item.id }}",
        ) {{ item[header.value] }}

        //- others
        span(v-else) {{ propOrEmpty(header.display, item, header.defaultValue) }}
    ConfirmDelete(
      v-else,
      :columns="headers.length",
      :confirmation-key="item[confirmationKey]",
      :removed="removed",
      :type="type",
      @confirm="toggle",
      @cancel="showDelete = false",
    )

</template>

<script>
import { formatDate } from '@/utils/helper';
import { propOr } from 'ramda';
import { roleManager } from '@/config/mixins';

import ConfirmDelete from '@/components/table/ConfirmDelete.vue';
import ColumnDate from '@/components/table/ColumnDate.vue';

export default {
  components: {
    ConfirmDelete,
    ColumnDate,
  },

  mixins: [roleManager],

  props: {
    headers: {
      type: Array,
      required: true,
    },

    misc: {
      type: Object,
      required: true,
    },

    item: {
      type: Object,
      required: true,
    },

    confirmationKey: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      required: true,
    },

    link: {
      type: String,
      default: '',
    },

    hideHover: {
      type: Boolean,
      default: false,
    },

    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    removed() {
      if (['shop', 'user'].includes(this.type)) {
        return this.item.is_deleted;
      } else {
        return this.item.is_deactivated;
      }
    },
  },

  methods: {
    propOrEmpty(path, item, defaultValue = '') {
      return propOr(defaultValue, path, item);
    },

    toggle() {
      const action = this.removed ? 'reactivate' : 'remove';
      this.$store.dispatch(`${this.type}/${action}`, this.item.id).then(() => {
        this.showDelete = false;
        this.$emit('deleted');
      });
    },
  },

  data: () => ({
    hover: false,
    showDelete: false,
  }),
};
</script>

<style lang="scss" scoped>
.table_thumbnail {
  max-height: 32px;
}

.align-right {
  text-align: right;
}

.row_confirmation_buttons {
  min-width: 300px;
}
</style>
